import React from "react";
import { Row, Col } from "antd";
import "./BikeShops.css";

const BikeShops: React.FC = () => {
  return (
    <div className="participating-shops">
      <div className="page-container">
        <Row gutter={20}>
          <Col xs={24} lg={8}>
            <div className="shops-content">
              <h1 className="page-title">
                Find Participating Bike Shops in your area
              </h1>

              <div className="search-section">
                <div className="search-label">Enter City or Zip Code</div>
                <div className="search-input-container">
                  <div className="search-input">
                    <span className="search-placeholder">Search</span>
                    <img
                      src="/images/search-icon.svg"
                      alt="Search"
                      className="search-icon"
                    />
                  </div>
                </div>
              </div>

              <div className="shops-list">
                <div className="shop-item">
                  <h3 className="shop-name">
                  Ebike Nola Electric Bike Sales & Rentals
                  </h3>
                  <div className="shop-details">
                    <div className="shop-address">
                      223 Dauphine St
                      <br />
                      New Orleans, LA 70112
                      <br />
                      (504) 533-9688
                    </div>
                    <div className="directions-link">
                      <a
                        href="https://maps.app.goo.gl/DvBfb22xTVcU2bLY8"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="get-directions"
                      >
                        Get Directions
                      </a>
                    </div>
                  </div>
                </div>

                <div className="shop-divider"></div>

                <div className="shop-item">
                  <h3 className="shop-name">Buzz Nola Bike Tours & Rentals, Electric Bike Tours and Rentals & Sales</h3>
                  <div className="shop-details">
                    <div className="shop-address">
                    223 Dauphine St
                      <br />
                      New Orleans, LA 70112
                      <br />
                      <a
                        href="https://maps.app.goo.gl/q9QKCX5G9HJZaSvp6"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (503) 233-5973
                      </a>
                    </div>
                    <div className="directions-link">
                      <a
                        href="https://maps.app.goo.gl/q9QKCX5G9HJZaSvp6"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="get-directions"
                      >
                        Get Directions
                      </a>
                    </div>
                  </div>
                </div>

                <div className="shop-divider"></div>

                <div className="shop-item">
                  <h3 className="shop-name">RideTHISbike</h3>
                  <div className="shop-details">
                    <div className="shop-address">
                    231 Dauphine St
                      <br />
                      New Orleans, LA 70112
                      <br />
                      <a
                        href="https://maps.app.goo.gl/pKwmPmgSk9sa4Cco9"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (503) 954-2620
                      </a>
                    </div>
                    <div className="directions-link">
                      <a
                        href="https://maps.app.goo.gl/pKwmPmgSk9sa4Cco997202"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="get-directions"
                      >
                        Get Directions
                      </a>
                    </div>
                  </div>
                </div>

                <div className="shop-divider"></div>

                <div className="shop-item">
                  <h3 className="shop-name">Bicycle Michael's</h3>
                  <div className="shop-details">
                    <div className="shop-address">
                      622 Frenchmen St
                      <br />
                      New Orleans, LA 70116
                      <br />
                      <a
                        href="https://maps.app.goo.gl/JModBwbxLHCScGKi7"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (503) 885-4813
                      </a>
                    </div>
                    <div className="directions-link">
                      <a
                        href="https://maps.app.goo.gl/JModBwbxLHCScGKi7"
                        rel="noopener noreferrer"
                        className="get-directions"
                      >
                        Get Directions
                      </a>
                    </div>
                  </div>
                </div>

                <div className="shop-divider"></div>
              </div>
            </div>
          </Col>
          <Col xs={24} lg={16}>
            <div className="map-container">
              <img
                src="/images/map-placeholder.webp"
                alt="Map showing participating bike shops"
                className="map-image"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BikeShops;
